import "./App.css";
import Routes from "components/Nav/Routes/Routes";

function App() {
  return <Routes />;
}

export default App;
